import { Navigate } from "react-router-dom";

import { Root } from "@/layouts";
import { COMMON, SPOWNER, TDCLIENT, TDADMIN } from "@/pages";
import { RequirePage } from "../protection";

const COMMONRoutes = [
  {
    path: "",
    element: <Navigate to={"/dashboard/analytics"} />,
  },
  {
    path: "dashboard",
    element: <Root />,
    children: [
      { path: "analytics", element: <RequirePage pageKey="ANALYTICS"><COMMON.Analytics /></RequirePage> },
      { path: "validate/:id", element: <COMMON.FirstSaleValidate /> },
      {
        path: "potential",
        element: <RequirePage pageKey="POTENTIAL_SAVINGS"><COMMON.Potential /></RequirePage>,
        children: [
          { path: "first-sale", element: <COMMON.FirstSale /> },
          {
            path: "preferential-origin",
            element: <COMMON.PreferentialOrigin />,
          },
          {
            path: "ftz",
            element: <COMMON.FTZ />,
          },
          // MTB route retired
          {
            path: "exclusions",
            element: <COMMON.Exclusions />,
          },
        ],
      },
      { path: "historical", element: <COMMON.Historical /> },
      { path: "risk-and-trends", element: <COMMON.RiskAndTrends /> },
    ],
  },
  {
    path: "scenario-modeling",
    element: <Root />,
    children: [{
      path: "",
      element: <RequirePage pageKey="SCENARIO_MODELING"><COMMON.ScenarioModeling /></RequirePage>
    }],
  },
  {
    path: "chat-advisor",
    element: <Root />,
    children: [{ path: "", element: <RequirePage pageKey="CHAT_ASSISTANCE"><COMMON.ChatAdvisor /></RequirePage> }],
  },
  {
    path: "product-catalogue",
    element: <Root />,
    children: [{
      path: "",
      element: <RequirePage pageKey="PRODUCT_HUB"><COMMON.ProductCatalogue /></RequirePage>
    }],
  },
  {
    path: "trade-data",
    element: <Root />,
    children: [{
      path: "",
      element: <RequirePage pageKey="TRADE_DATA"><COMMON.TradeData /></RequirePage>
    }],
  },
  {
    path: "documents",
    element: <Root />,
    children: [
      {
        path: "",
        element: <COMMON.Documents />,
        children: [
          { path: "", element: <Navigate to="creation" /> },
          {
            path: "creation",
                element: <RequirePage pageKey="DOCUMENTS"><COMMON.Creation /></RequirePage>,
            children: [
              { path: "", element: <Navigate to="certificate-of-origin" /> },
              { path: "certificate-of-origin", element: <COMMON.CertificateOfOrigin /> },
            ],
          },
          {
            path: "storage",
            element: <COMMON.Storage />,
            children: [
              { path: "", element: <Navigate to="entry-summary" /> },
              { path: "entry-summary", element: <COMMON.EntrySummary /> },
            ],
          },
        ],
      },
    ],
  },
  {
    path: "post-import-adjustment",
    element: <Root />,
    children: [
      { path: "", element: <RequirePage pageKey="POST_IMPORT_ADJUSTMENT"><COMMON.PostImportAdjustment /></RequirePage> },
    ],
  },
  {
    path: "settings",
    element: <COMMON.Settings />,
    children: [
      { path: "account-settings", element: <COMMON.AccountSettings /> },
      { path: "changelog", element: <COMMON.Changelog /> },
    ],
  },
  {
    path: "help-center",
    element: <Root />,
    children: [{ path: "", element: <COMMON.HelpCenter /> }],
  },
];

const SPOWNERRoutes = [
  ...COMMONRoutes,
  {
    path: "partners",
    element: <Root />,
    children: [{ path: "", element: <SPOWNER.SPOWNERPartners /> }],
  },
  {
    path: "clients",
    element: <Root />,
    children: [{ path: "", element: <SPOWNER.SPOWNERClients /> }],
  },
];

const SPPARTNERRoutes = [...COMMONRoutes];

const SPCLIENTRoutes = [...COMMONRoutes];

const TDCLIENTRoutes = [
  ...COMMONRoutes,
  {
    path: "users",
    element: <Root />,
    children: [{ path: "", element: <TDCLIENT.TDClIENTUsers /> }],
  },
];

const TDADMINRoutes = [...COMMONRoutes,{
  path: "/tenant-management",
  element: <Root />,
  children: [{ path: "", element: <TDADMIN.TDADMINTenantManagement /> }],
},];

const TDADMIN_SPRoutes = [
  {
    path: "partners",
    element: <Root />,
    children: [{ path: "", element: <SPOWNER.SPOWNERPartners /> }],
  },
  {
    path: "clients",
    element: <Root />,
    children: [{ path: "", element: <SPOWNER.SPOWNERClients /> }],
  },
];

export const RolesRoutes = {
  SPOWNER: [...SPOWNERRoutes],
  SPPARTNER: [...SPPARTNERRoutes],
  SPCLIENT: [...SPCLIENTRoutes],
  TDCLIENT: [...TDCLIENTRoutes],
  TDADMIN: [...TDADMINRoutes],
  TDADMIN_SP: [...TDADMIN_SPRoutes],
};
